export const ApplyFilter = {
  DEFAULT: "API_APPLY_FILTER_DEFAULT",
  RESET: "API_APPLY_FILTER_RESET",
  SHARE: "API_APPLY_FILTER_SHARE",
};
